import React, { Component } from "react";
import CompaniesMapDistribution from "./CompaniesMapDistribution";
import { message } from "antd";
import axios from "axios";
import _ from "lodash";
const { getName } = require("country-list");

const CancelToken = axios.CancelToken;

class CompaniesMapWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loading: false,
    };
    this.axiosCancelFetchData = null;
  }

  fetchData = (startDate, endDate) => {
    this.setState({
      data: {},
      loading: true,
    });

    axios
      .get(
        process.env.REACT_APP_API_ROOT + "/dashboard/companiesMapDistribution",
        {
          params: {
            "period[start]": startDate.toDate(),
            "period[end]": endDate.toDate(),
          },
          headers: {
            Authorization: localStorage.getItem("jwt"),
          },
          cancelToken: new CancelToken((c) => {
            this.axiosCancelFetchData = c;
          }),
        }
      )
      .then(
        function (response) {
          let data = {};

          response.data.forEach((e, i) => {
            data[getName(e._id)] = e.count;
          });

          console.log(data);

          this.setState({
            data: data,
            loading: false,
          });
        }.bind(this)
      )
      .catch((e) => {
        if (!axios.isCancel(e)) {
          message.error("Could not fetch Companies Distribution data");
        }
      });
  };

  componentDidMount() {
    const { startDate, endDate } = this.props;
    this.fetchData(startDate, endDate);
  }

  componentDidUpdate(prevProps) {
    const { startDate, endDate } = this.props;

    if (
      this.props.startDate !== prevProps.startDate ||
      this.props.endDate !== prevProps.endDate
    ) {
      this.fetchData(startDate, endDate);
    }
  }

  componentWillUnmount() {
    this.axiosCancelFetchData();
  }

  render() {
    return (
      <CompaniesMapDistribution
        data={this.state.data}
        loading={this.state.loading}
      />
    );
  }
}

export default CompaniesMapWrapper;
